<template lang="html">
	<div class="row my-4" v-if="loading">
		<div class="col-12">
			<vue-content-loading secondary="#ffc107">
                <rect x="0" y="0"  rx="5" ry="5" width="100%" height="10" />
                <rect x="0" y="15" rx="5" ry="5" width="100%" height="10" />
                <rect x="0" y="30" rx="5" ry="5" width="100%" height="10" />
            </vue-content-loading>
		</div>
	</div>
</template>

<script>
import VueContentLoading from 'vue-content-loading';

export default {
    components: {
        VueContentLoading,
    },
	props: {
		loading: {
			type: Boolean,
			default: false
		}
	}
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// PartialLoader.vue?b196a026